module.exports = __webpack_public_path__ + "static/img/wly.4bba26b2.png";